"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMPETENCY_IMPORT_FILE_TOO_LARGE_COPY () {
        return COMPETENCY_IMPORT_FILE_TOO_LARGE_COPY;
    },
    get COMPETENCY_IMPORT_UNSUPPORTED_TYPE_COPY () {
        return COMPETENCY_IMPORT_UNSUPPORTED_TYPE_COPY;
    },
    get MAX_ACTIVE_ROLES_FOR_AUTO_CREATE () {
        return MAX_ACTIVE_ROLES_FOR_AUTO_CREATE;
    },
    get MAX_AUTO_CREATED_ROLES_PER_INGEST () {
        return MAX_AUTO_CREATED_ROLES_PER_INGEST;
    },
    get MAX_COMPETENCY_FRAMEWORK_SIZE () {
        return MAX_COMPETENCY_FRAMEWORK_SIZE;
    },
    get MAX_COMPETENCY_IMPORT_BYTES () {
        return MAX_COMPETENCY_IMPORT_BYTES;
    },
    get MAX_COMPETENCY_LEVELS () {
        return MAX_COMPETENCY_LEVELS;
    },
    get MAX_COMPETENCY_NAME_LENGTH () {
        return MAX_COMPETENCY_NAME_LENGTH;
    },
    get MAX_ROLE_LADDER_NAME_LENGTH () {
        return MAX_ROLE_LADDER_NAME_LENGTH;
    },
    get MAX_ROLE_NAME_LENGTH () {
        return MAX_ROLE_NAME_LENGTH;
    }
});
const MAX_COMPETENCY_LEVELS = 5;
const MAX_COMPETENCY_NAME_LENGTH = 250;
const MAX_ROLE_NAME_LENGTH = 250;
const MAX_AUTO_CREATED_ROLES_PER_INGEST = 100;
const MAX_ACTIVE_ROLES_FOR_AUTO_CREATE = 200;
const MAX_ROLE_LADDER_NAME_LENGTH = 250;
const MAX_COMPETENCY_FRAMEWORK_SIZE = 100;
const MAX_COMPETENCY_IMPORT_BYTES = 10 * 1024 * 1024;
const COMPETENCY_IMPORT_FILE_TOO_LARGE_COPY = "This file is too large. Please upload a PDF under 10 MB.";
const COMPETENCY_IMPORT_UNSUPPORTED_TYPE_COPY = "Supported file type is PDF. Try saving your document as a PDF and uploading again.";
